import React, { FC, useContext } from 'react';
import styles from './ErrorBlock.module.scss';
import { classnames } from '@src/utils/classnames';
import { Notification } from '@src/atoms/Notification';
import { MediaUploaderContext } from '../context';

export interface IErrorBlockProps {
  errorCode: string;
  fileList: string[];
  maxFiles: number;
  maxFileSizeMB: number;
  acceptedFiles: string;
}

export const ErrorBlock: FC<IErrorBlockProps> = ({ errorCode, fileList, maxFiles, maxFileSizeMB, acceptedFiles }) => {
  const { controller } = useContext(MediaUploaderContext);

  const ERROR_TITLES = {
    'file-invalid-type': () => `Не все файлы были загружены`,
    'file-too-large': (count: number) => `${count > 1 ? 'Файлы' : 'Файл'} слишком большого размера`,
    'too-many-files': () => `Не все файлы были загружены`,
  };

  const ERROR_CONTENS = {
    'file-invalid-type': (fileList: string[]) =>
      `${fileList.length > 1 ? 'Файлы' : 'Файл'} ${fileList.map(
        (f, i) => `${f}${i + 1 === fileList.length ? '' : ','}`,
      )} не загружен${fileList.length > 1 ? 'ы' : ''}. Форматы доступные для загрузки: ${acceptedFiles}`,
    'file-too-large': (fileList: string[]) =>
      `${fileList.length > 1 ? 'Файлы' : 'Файл'} ${fileList.map(
        (f, i) => `${f}${i + 1 === fileList.length ? '' : ','}`,
      )} не загружен${fileList.length > 1 ? 'ы' : ''}. Максимальный размер файла ${maxFileSizeMB} Мб.`,
    'too-many-files': () => `Превышен лимит в ${maxFiles} файлов на единоразовую загрузку`,
  };

  const title = ERROR_TITLES[errorCode](fileList.length);
  const content = ERROR_CONTENS[errorCode](fileList);

  const classes = classnames(styles.root, styles.width);

  const handleClose = () => {
    controller.errorsMap.delete(errorCode);
    controller.setStateErrors(new Map(controller.errorsMap));
  };

  return (
    <Notification mode={'banner'} view={'error'} title={title} className={classes} onClose={handleClose}>
      {content}
    </Notification>
  );
};
